import { Language, PathLanguage } from "../config/languages";

/**
 * Convert Language to PathLanguage
 * @param lang
 * @return pathLang
 */
export function getPathLanguage(lang: Language): PathLanguage {
  if (lang === "en-us") return "en";
  return lang;
}
